<script>
import { Student } from '@/api'
import HeaderTabsContent from '@/views/Layouts/HeaderTabsContent'

export default {
  extends: HeaderTabsContent,
  computed: {
    service() {
      return Student
    },
    title() {
      return this.instance ? this.instance.full_name : 'Dodaj nowego kursanta'
    },
    avatar() {
      return this.instance && this.instance.avatar_preview
    },
    routes() {
      const params = this.$route.params
      return [
        {
          label: 'Profil kursanta',
          icon: 'user',
          to: `/admin/kursanci/szczegoly/${params.studentId}/edytuj/`
        },
        {
          label: 'Kalendarz',
          icon: 'calendar',
          to: `/admin/kursanci/szczegoly/${params.studentId}/kalendarz/`
        },
        {
          label: 'Kursy',
          icon: 'laptop',
          to: `/admin/kursanci/szczegoly/${params.studentId}/kursy/`
        },
        {
          label: 'Aplikacje',
          icon: 'appstore',
          to: `/admin/kursanci/szczegoly/${params.studentId}/aplikacje/`
        },
        {
          label: 'Rozliczenia i umowy',
          icon: 'book',
          to: `/admin/kursanci/szczegoly/${params.studentId}/rozliczenia/`
        },
        {
          label: 'Notatki wewnętrzne',
          icon: 'book',
          to: `/admin/kursanci/szczegoly/${params.studentId}/notatki/`
        }
      ]
    },
    params() {
      return this.$route.params.studentId
    }
  }
}
</script>
